require("-!style-loader!css-loader!./../../node_modules/.npminstall/vue-loader/7.1.7/vue-loader/lib/style-rewriter.js?id=_v-b99673b2&file=affixDocs.vue!./../../node_modules/.npminstall/vue-loader/7.1.7/vue-loader/lib/selector.js?type=style&index=0!./affixDocs.vue")
module.exports = require("-!babel!./../../node_modules/.npminstall/vue-loader/7.1.7/vue-loader/lib/selector.js?type=script&index=0!./affixDocs.vue")

if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function" ? module.exports.options : module.exports).template = require("-!vue-html-loader!./../../node_modules/.npminstall/vue-loader/7.1.7/vue-loader/lib/selector.js?type=template&index=0!./affixDocs.vue")
if (module.hot) {
(function () {
var hotAPI = require("vue-hot-reload-api")
hotAPI.install(require("vue"))
if (!hotAPI.compatible) return
var id = "-!babel!./../../node_modules/.npminstall/vue-loader/7.1.7/vue-loader/lib/selector.js?type=script&index=0!./affixDocs.vue"
hotAPI.createRecord(id, module.exports)
module.hot.accept(["-!babel!./../../node_modules/.npminstall/vue-loader/7.1.7/vue-loader/lib/selector.js?type=script&index=0!./affixDocs.vue","-!vue-html-loader!./../../node_modules/.npminstall/vue-loader/7.1.7/vue-loader/lib/selector.js?type=template&index=0!./affixDocs.vue"], function () {
var newOptions = require("-!babel!./../../node_modules/.npminstall/vue-loader/7.1.7/vue-loader/lib/selector.js?type=script&index=0!./affixDocs.vue")
if (newOptions && newOptions.__esModule) newOptions = newOptions.default
var newTemplate = require("-!vue-html-loader!./../../node_modules/.npminstall/vue-loader/7.1.7/vue-loader/lib/selector.js?type=template&index=0!./affixDocs.vue")
hotAPI.update(id, newOptions, newTemplate)
})
})()
}


//////////////////
// WEBPACK FOOTER
// ./docs/example/affixDocs.vue
// module id = 177
// module chunks = 0